import { LiabilityPaymentFrequency } from '@/types/schema';

import { LiabilityFormShape } from './LiabilityModal.constants';

interface LiabilityIntegrationFieldSource {
  _showExpandedPaymentDetails?: boolean;
  name?: string | null;
  balanceAsOfDate?: unknown;
  outstandingBalance?: unknown;
  paymentAmount?: unknown;
  paymentFrequency?: string | null;
  interestRate?: unknown;
  termStartDate?: unknown;
  termEndDate?: unknown;
}

export function getLiabilityIntegrationPrefilledFields(
  values: LiabilityIntegrationFieldSource | undefined
): Set<keyof LiabilityFormShape> {
  const fields = new Set<keyof LiabilityFormShape>();

  if (!values) return fields;

  if (values.name) fields.add('name');
  if (values.balanceAsOfDate) fields.add('balanceAsOfDate');
  if (values.outstandingBalance != null) fields.add('outstandingBalance');
  if (values._showExpandedPaymentDetails !== false) {
    if (values.paymentAmount != null) fields.add('paymentAmount');
    if (values.paymentFrequency) fields.add('paymentFrequency');
    if (values.interestRate != null) fields.add('interestRate');
    if (values.termStartDate) fields.add('termStartDate');
    if (values.termEndDate) fields.add('termEndDate');
  }

  return fields;
}

const PAYMENT_DETAIL_FIELDS: ReadonlyArray<keyof LiabilityFormShape> = [
  'paymentAmount',
  'paymentFrequency',
  'interestRate',
  'termStartDate',
  'termEndDate',
];

export function hasLiabilityIntegrationPaymentDetails(
  fields: ReadonlySet<keyof LiabilityFormShape>
): boolean {
  return PAYMENT_DETAIL_FIELDS.some((field) => fields.has(field));
}

export function getLiabilityIntegrationPaymentFrequency(
  paymentFrequency: string | null | undefined
): LiabilityPaymentFrequency | null {
  switch (paymentFrequency) {
    case LiabilityPaymentFrequency.Monthly:
      return LiabilityPaymentFrequency.Monthly;
    case LiabilityPaymentFrequency.Quarterly:
      return LiabilityPaymentFrequency.Quarterly;
    case LiabilityPaymentFrequency.Semiannually:
      return LiabilityPaymentFrequency.Semiannually;
    case LiabilityPaymentFrequency.Annually:
      return LiabilityPaymentFrequency.Annually;
    default:
      return null;
  }
}
